exports = module.exports = require("../../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ItemQestionBlock{position:absolute;width:200px;height:50px;border-radius:0;background:#fff}.ItemQestionBlock textarea{width:100%;height:100%;border:1px solid #d8d8d8;border-radius:0;text-align:center}.ItemQestionBlock .icon{position:absolute;width:30px;height:30px;right:-15px;top:-15px;display:flex;align-items:center;justify-content:center;background:#f4f2fe;border-radius:50%;cursor:pointer;border:1px solid #d8d8d8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType6/components/LineLabel/style.scss
// module id = 4894
// module chunks = 0